import '../../scss/dotted-placeholder.scss';

export enum EDottedPlaceholder {
    HORIZONTAL = 'horizontal',
    VERTICAL = 'vertical',
    LEAF = 'leaf',
    LEAF_LAST = 'leaf last',
}

export const DottedPlaceholder = ({ type }: { type: EDottedPlaceholder }) => {
    return (
        <div className={`dotted-placeholder ${type}`}>
            <div className='dotted-placeholder-inner'>
                
            </div>
        </div>
    )
}